module.exports = __webpack_public_path__ + "img/answer.24bb0e49.png";